import(/* webpackMode: "eager" */ "/app/app/[locale]/(site)/event/error.tsx");
